import { render, staticRenderFns } from "./RecipeItem.vue?vue&type=template&id=40bd34a5&scoped=true&"
import script from "./RecipeItem.vue?vue&type=script&lang=js&"
export * from "./RecipeItem.vue?vue&type=script&lang=js&"
import style0 from "./RecipeItem.vue?vue&type=style&index=0&id=40bd34a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bd34a5",
  null
  
)

export default component.exports